<div class="lottie">
    <ng-lottie *ngIf="lottie" class="lottie-item" [options]="filePath"></ng-lottie>
</div>
